<cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
  <div class="cap-list-loader-content">
    <table class="cap-table-detail">
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRowsGrundbuchplaene"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>
<ng-template #tableRowsGrundbuchplaene>
  @if (listLoader?.items) {
    @for (plan of listLoader?.items; track plan) {
      @for (version of plan.versions; track version) {
        <tr>
          <td>
            @if (version.planNummer) {
              <span [capHistinfo]="version.histInfo">
                {{ version.planNummer }}
              </span>
            }
            @if (version.katasterNummer) {
              <span [capHistinfo]="version.histInfo">
                @if (version.planNummer) {
                  <span>, </span>
                }
                <span>{{ "Katasternummer" | translate }}</span
                >:
                {{ version.katasterNummer }}
              </span>
            }
            <cap-kompakt-timepoint [item]="version.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
          </td>
        </tr>
      }
    }
  }
</ng-template>
